export default "__VITE_ASSET__DXiuAMCg__"